const state = {
}

const getters = {
}

const mutations = {
}

const DIRECT_URL_KEYS = [
  'url',
  'imageUrl',
  'imageURL',
  'image_url',
  'voucherUrl',
  'voucher_url',
  'fileUrl',
  'file_url',
]

const DOMAIN_KEYS = ['imageDomain', 'image_domain', 'domain']
const RELATIVE_URL_KEYS = [
  'imageRelativeUrl',
  'image_relative_url',
  'relativeUrl',
  'relative_url',
]

function findStringValue (source, keys) {
  if (!source || typeof source !== 'object') return ''
  const key = keys.find(key => typeof source[key] === 'string' && source[key].trim())
  return key ? source[key].trim() : ''
}

function joinUrl (domain, relativeUrl) {
  if (/^(https?:)?\/\//.test(relativeUrl)) return relativeUrl
  return `${domain.replace(/\/+$/, '')}/${relativeUrl.replace(/^\/+/, '')}`
}

// 兼容平台接口的新旧响应结构，统一向上传组件返回完整 URL。
export function resolveRefundVoucherUrl (payload, visited = new Set()) {
  if (typeof payload === 'string') {
    const url = payload.trim()
    return /^(https?:)?\/\//.test(url) || url.startsWith('/') ? url : ''
  }
  if (!payload || typeof payload !== 'object' || visited.has(payload)) return ''
  visited.add(payload)

  const domain = findStringValue(payload, DOMAIN_KEYS)
  const relativeUrl = findStringValue(payload, RELATIVE_URL_KEYS)
  if (domain && relativeUrl) return joinUrl(domain, relativeUrl)

  const directUrl = findStringValue(payload, DIRECT_URL_KEYS)
  if (directUrl) return directUrl

  for (const value of Object.values(payload)) {
    const url = resolveRefundVoucherUrl(value, visited)
    if (url) return url
  }
  return ''
}

const actions = {
  create ({ state, commit, rootState }, params) {
    return rootState.axios.post('/magicbuy/ali-dg/trade/refund/create', params, {
      baseURL: 'https://apisp.jyb.com.tw',
    })
  },
  async uploadRefundVoucher ({ state, commit, rootState }, params) {
    const res = await rootState.axios.post('/magicbuy/ali-dg/trade/refund/upload-refund-voucher', params, {
      baseURL: 'https://apisp.jyb.com.tw',
      headers: { 'Content-Type': 'multipart/form-data' },
    })
    const url = resolveRefundVoucherUrl(res.data)
    if (!url) {
      throw new Error('圖片上傳結果缺少網址')
    }
    return {
      ...res,
      data: { url },
    }
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
